/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const SearchTransmittalRecordsParams = zod.object({

}).passthrough()

export type SearchTransmittalRecordsParams = zod.input<typeof SearchTransmittalRecordsParams>;
export type SearchTransmittalRecordsParamsOutput = zod.output<typeof SearchTransmittalRecordsParams>;
